import {BlobServiceClient} from "@azure/storage-blob";
import {InjectionToken} from "@angular/core";

export interface BlobStorageRequest {
    storageUri: string;
    storageAccessToken: string;
}

export type BlobStorageClientFactory = (
    options: BlobStorageRequest
) => BlobServiceClient;

export interface BlobContainerRequest extends BlobStorageRequest {
    containerName: string;
}

export interface BlobFileRequest extends BlobContainerRequest {
    fileName: string;
}

export interface BlobItem {
    fileName: string;
    containerName: string;
    data: any;
}

export const BLOB_STORAGE_TOKEN = new InjectionToken<BlobStorageClientFactory>(
    'BLOB_STORAGE_TOKEN'
)

export function azureBlobStorageFactory() : BlobStorageClientFactory {
    const buildConnectionString = (options: BlobStorageRequest) => {
        return (
            `BlobEndpoint=${options.storageUri};` +
                `SharedAccessSignature=${options.storageAccessToken}`
        )
    }

    return options => BlobServiceClient.fromConnectionString(buildConnectionString(options));
}
